import * as React from 'react'

import { fmtQty } from '@/components/domain'
import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import type { Task } from '@/data/types'

/**
 * "Quanto foi entregue?" ao fechar uma tarefa com mais de uma unidade. Entrega
 * parcial continua Realizada; o desempenho conta só o entregue.
 */
export function DeliveredDialog({
  task,
  onConfirm,
  onCancel,
}: {
  task: Task | null
  onConfirm: (qtd: number) => void
  onCancel: () => void
}) {
  const [value, setValue] = React.useState('')
  React.useEffect(() => {
    if (task) setValue(String(task.qtd_entregue || task.qtd_prevista))
  }, [task])

  const qtd = Number(value.replace(',', '.'))
  const valid = task !== null && Number.isFinite(qtd) && qtd >= 0 && qtd <= task.qtd_prevista

  return (
    <Dialog open={task !== null} onOpenChange={(o) => !o && onCancel()}>
      <DialogContent className="sm:max-w-sm">
        <DialogHeader>
          <DialogTitle>Quanto foi entregue?</DialogTitle>
          <DialogDescription>
            {task?.key} · previsto {task ? fmtQty(task.qtd_prevista) : ''} un. Entrega parcial conta no desempenho pelo que foi entregue.
          </DialogDescription>
        </DialogHeader>
        <form
          id="delivered-form"
          onSubmit={(e) => {
            e.preventDefault()
            if (valid) onConfirm(qtd)
          }}
          className="space-y-2"
        >
          <Label htmlFor="delivered-qty">Quantidade entregue</Label>
          <Input
            id="delivered-qty"
            inputMode="decimal"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            aria-invalid={!valid}
            className="font-mono tabular-nums"
            autoFocus
          />
          {!valid && task && (
            <p className="text-xs text-destructive">Informe um número entre 0 e {fmtQty(task.qtd_prevista)}.</p>
          )}
        </form>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={onCancel}>
            Cancelar
          </Button>
          <Button type="submit" form="delivered-form" disabled={!valid}>
            Marcar como realizada
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
